import { Alert, Snackbar } from "@mui/material";
import React from "react";

const ToastMessage = (props) => {
  const handleClose = () => {
    props.onClose(false);
  };

  return (
    <>
      <Snackbar
        open={props.open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          variant="filled"
          severity={props.toastData.severity}
          onClose={handleClose}
          sx={{ width: "100%" }}
        >
          {props.toastData.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ToastMessage;
